<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <span>账号：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryUserName" @input="getList"></el-input>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="userName" label="账号" min-width="150px"></el-table-column>
        <el-table-column prop="nickName" label="姓名" min-width="150px"></el-table-column>
        <el-table-column prop="roleInfoVo.roleName" label="角色" min-width="150px"></el-table-column>
        <el-table-column label="操作" min-width="150px">
          <template slot-scope="scope">
            <el-button v-if="modifyPower" type="text" size="small" @click="setModify(tableData[scope.$index])">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isLoading: true,
      thisModule: [],
      tableData: [],
      modifyPower: false,
      queryUserName: ''
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.user.children.medOwner.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      if ((powers[200].powerValue & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 判断临时缓存是否存在
    this.myOption.getScreenData(this, 'screen-media')
    // 调用获取列表函数
    this.getList()
  },
  methods: {
    // 获取列表
    getList () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify({
          isSspUser: 1,
          userName: this.queryUserName,
          startPage: this.$store.state.user.currentPage,
          pageSize: this.$store.state.user.pageSize
        })
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          this.tableData = res.data.data.data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 修改
    setModify (data) {
      let param = {}
      if (this.queryUserName !== '') {
        param.queryUserName = this.queryUserName
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-media', JSON.stringify(param))
      }
      this.$store.dispatch('SetEditId', {id: data.userId, copy: false})
      this.myOption.switchListAndEdit(this, false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media_owner/List.vue